import { useErrorBoundary } from 'preact/hooks';
import type { ComponentChildren } from 'preact';

interface WidgetErrorBoundaryProps {
  children: ComponentChildren;
  /** `reset` clears the caught error and re-renders — wire it to "try again". */
  fallback: (reset: () => void) => ComponentChildren;
}

/** One boundary primitive, reused per layer (app / marketplace / outreach) with its fallback. */
export function WidgetErrorBoundary({ children, fallback }: WidgetErrorBoundaryProps) {
  const [error, reset] = useErrorBoundary((err) =>
    console.error('[sell-more] boundary caught:', err),
  );

  if (error !== undefined) {
    return <>{fallback(reset)}</>;
  }

  return <>{children}</>;
}
